/* eslint-disable */
import axios from 'axios';


export default {

    state : {
        cloudUploadFiles : [],
        uploadingFiles : [],
        uploadedExt : ['TIF','TIFF','CDR','EPS','PDF'],

        cloudFiles : [], // список файлов уже в облаке

    },

   
    getters : {
        getCloudFiles(state){
            return state.cloudFiles;
        },

        needToCloudUpload(state) {

            let f = state.cloudUploadFiles; // получаем все файлы для загрузки
            var isCloudUpload = false; // флаг загрузки на сервер

            f.forEach(item => { // бежим по всем файлам и проверяем есть ли тиф и тд
                var parts, ext = ( parts = item.name.split("/").pop().split(".") ).length > 1 ? parts.pop() : ""; // получили расширение
                ext = ext.toUpperCase();
                let q = state.uploadedExt.findIndex(item => item === ext);
                if (q > -1) isCloudUpload = true;
            });
            return isCloudUpload;

        },

        getUploadingFiles(state) {
            return state.uploadingFiles;
        },

        getUploadFiles(state) {
            return state.cloudUploadFiles;
        },

        isOrderUpload: state => id => {
            return state.uploadingFiles.find(item => {
               return item.orderId === id;
           });
       },

    },

    mutations: {

        clearUploadFiles(state) { //очищаем массив для загрузки 
            state.cloudUploadFiles.splice(0, state.cloudUploadFiles.length);
        },

        deleteFileFromUpload(state, name) { // удаляем файл из списка загрузки
            const index =  state.cloudUploadFiles.findIndex(item => item.name === name);
            state.cloudUploadFiles.splice(index, 1);
        },

        deleteUploadingFile(state, data) {
            const index =  state.uploadingFiles.findIndex(item => item.id === data.id);
            state.uploadingFiles.splice(index, 1);
        },
        
        updatePercent(state, data) {
            const index =  state.uploadingFiles.findIndex(item => item.id === data.id);
            let q = state.uploadingFiles[index];
            q.percent = data.percent;
            state.uploadingFiles.splice(index, 1, q);
        },

        addUploadingFile(state,  data) {
            state.uploadingFiles.push(data);
            // нужно добавить флаг в данные заказа - что идет загрузка.          
        },

        addNewUploadFile(state, data) {
            state.cloudUploadFiles.push(data);
        },

        clearNewUploadFile(state) {
            state.cloudUploadFiles.splice(0, state.cloudUploadFiles.length);
        },

        setCloudFiles(state, data) {
            state.cloudFiles = data;
        },
        
        deleteCloudFile(state, key) {
            const index =  state.cloudFiles.findIndex(item => item.key === key);
            state.cloudFiles.splice(index, 1);
        }
    },

    actions : {

        getCloudFiles(context, id) {  // Экшен через сервер загружает список файлов, которые принадлежат этому заказу

            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.get('/getCloudFiles/'+id)  //запрашиваем у сервера список файлов
                .then(response => {
                    context.commit('setCloudFiles', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
             });
        },

        deleteFromCloud(context, key) {  // Экшен через сервер загружает список файлов, которые принадлежат этому заказу

            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.post('/deleteFromCloud',{key:key})  //удаляем файл key из облака, ответ - новый список
                .then(response => {
                    context.commit('deleteCloudFile', key);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
             });
        },

        startUploadFiles({dispatch, commit, state, rootState, rootGetters}, id) { // загрузка файлов

            var AWS = require('aws-sdk');
            var S3     = require('aws-sdk/clients/s3');
            AWS.config.update(
                {
                    region: 'ru-msk',
                    endpoint: 'http://hb.bizmrg.com',
                    credentials: 
                        {
                            // accessKeyId: 'bt9LBWUWYWLm4UiL1uskRd', 
                            // secretAccessKey: 'hrUdQuMeGULQ9v4cpmqvTXvkZ4CKpP9FMUDXkCF2M4Vi'
                            accessKeyId: '4QMFKPNwLQqox52SW6uG4F', 
                            secretAccessKey: '62aguSdD1tNCXdipmcqi9XuAXFKusDJhkZuVE95PKnXg'

                        }

                });
            var s3 = new AWS.S3();

            let f = rootGetters.getUploadFiles; // получаем все файлы для загрузки
            var isCloudUpload = false; // флаг загрузки на сервер

            f.forEach(item => { // бежим по всем файлам и проверяем есть ли тиф и тд
                var parts, ext = ( parts = item.name.split("/").pop().split(".") ).length > 1 ? parts.pop() : ""; // получили расширение
                ext = ext.toUpperCase();
                let q = state.uploadedExt.findIndex(item => item === ext);
                if (q > -1) isCloudUpload = true;
            });


            if (isCloudUpload) {

                f.forEach(item => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'addUploadingFile', 'content' : {id : item.name, percent : 0, name : item.name, orderId : id}});
                    // получаем имя бакета
                    let q = rootState.myCompany;
                    let bucketName = q != null ? 'advimatic'+ q.table_name.toLowerCase() : '';

                    s3.putObject({
                        Body: item,
                        // Bucket: "advimatic_df8mofpzdgu62o",
                        Bucket: bucketName,
                        Key: id+"/"+item.name,
                        ACL: 'public-read',
                        Tagging: "order="+id,
                    }, function(err, data){
                        if (err) console.log(err, err.stack); // an error occurred
                        else  {
                        //Закрываем  через 1 сек 
                            setTimeout(()=>{
                                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'deleteUploadingFile', 'content' : {id:item.name}});
                            }, 1000);
                        }
                    }
                    ).on('httpUploadProgress', function(progress) {
                        let p = Math.round(progress.loaded/progress.total*100);
                        commit('updatePercent', {id : item.name, percent : p}); //  обновляем процент
                    });
                });
            }

            commit('clearNewUploadFile');
  

        }
    }

}